import React, { useState } from 'react';

import { /*Tag,*/ Dropdown, Menu } from 'antd';

import { getMoment } from '@libs/NwMoment';
import { showDateNoTime, getExpirationInDays, getNow } from '@libs/NwMoment';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import CreatedBy from '@components/CreatedBy/CreatedBy';
import EventDrawer from '@components/EventDrawer/EventDrawer';
import NwEllipsis from '@components/Gui/NwEllipsis';
import NwIcon from '@components/Gui/NwIcon';
import { NwTag } from '@components/Gui/NwTag';
import ToDoCheck from '@components/Gui/ToDoCheck';
import ProjectLine from '@components/ProjectLine/ProjectLine';
import { TaskContainer, TaskCheckDropdownItem } from '@components/TaskList/TasksUI';

import TaskContactAvatars from './TaskContactAvatars';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const TaskCard = ({ onUpdate, previewMode, projectId, showAll, todoItem }) => {
    const [editDrawer, setEditDrawer] = useState(false);
    const [visible, showVisible] = useState(false);
    const [selectedId, setSelectedId] = useState(0);

    const openEventDrawer = (id) => {
        setEditDrawer(true);
        setSelectedId(id);
    };

    const closeEditDrawer = () => {
        setEditDrawer(false);
    };

    const todo = {
        ...todoItem,
        TypeName: 'ToDo',
        Completed: todoItem.GlobalStatus === 'Completed',
        HalfCompleted: todoItem.GlobalStatus === 'PartiallyCompleted',
    };

    const menuItems = [...todo.TodoContacts].map((model, index) => ({
        key: index,
        label: (
            <TaskCheckDropdownItem>
                <div className="name">{model.ContactID ? getContactName(model.ContactID) : 'No contact'}</div>
                <ToDoCheck
                    previewMode={previewMode}
                    onStatusChanged={() => onUpdate(model.ID)}
                    eventId={model.ID}
                    completedValue={model.Status}
                />
            </TaskCheckDropdownItem>
        ),
    }));

    const renderTag = (todo) => {
        const date = todo.Date;
        if (todo.GlobalStatus === 'Completed' || !date) return null;
        if (getExpirationInDays(date) === 'today') {
            return <NwTag type="warning">Due Today</NwTag>;
        }
        if (getMoment(date) < getNow()) {
            return <NwTag type="danger">Overdue {getExpirationInDays(date)}</NwTag>;
        }
    };

    return (
        <>
            <TaskContainer
                className="event-selected"
                onClick={() => !previewMode && openEventDrawer(todo.TodoContacts[0].ID)}
                showAll={showAll}
            >
                <div className="task-body">
                    <div className="task-toolbar">
                        {todo.TodoContacts && todo.TodoContacts.length > 1 ? (
                            <Dropdown
                                menu={{ items: menuItems }}
                                trigger={['click']}
                                open={visible}
                                onOpenChange={(visible) => {
                                    if (!visible) {
                                        showVisible(false);
                                    }
                                }}
                            >
                                <div className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                                    <ToDoCheck
                                        previewMode={previewMode}
                                        action={(e) => {
                                            showVisible(true);
                                            e.stopPropagation();
                                        }}
                                        completedValue={todo.Completed}
                                        halfCompletedValue={todo.HalfCompleted}
                                    />
                                </div>
                            </Dropdown>
                        ) : (
                            <ToDoCheck
                                previewMode={previewMode}
                                onStatusChanged={() => onUpdate(todo.TodoContacts[0].ID)}
                                eventId={todo.TodoContacts ? todo.TodoContacts[0].ID : todo.ContactID}
                                completedValue={todo.Completed}
                            />
                        )}
                    </div>
                    <div className="task-content">
                        <div className="task-content-top">
                            {todo.Project && !projectId && (
                                <div
                                    className={`task-projectline-container ${todo.PrivacyLevelName !== 'Public' ? 'with-tag' : ''}`}
                                >
                                    <ProjectLine project={todo.Project} ellipsis />
                                </div>
                            )}
                            {todo.PrivacyLevelName !== 'Public' && (
                                <div className="task-personal-tag">
                                    <NwTag type="primary">Personal</NwTag>
                                </div>
                            )}
                            <NwEllipsis
                                className={`task-title${(!todo.Project || projectId) && todo.PrivacyLevel !== 'Public' ? ' with-tag' : ''}`}
                                text={todo.Title}
                                rows={2}
                            />
                            <NwEllipsis className="task-description" text={todo.CommonDescription} rows={3} />
                        </div>
                        <div className="task-content-bottom">
                            <CreatedBy
                                author={todo.UserCreated}
                                date={todo.DateCreated ? todo.DateCreated : todo.Date}
                            />
                        </div>
                    </div>
                </div>
                <div className="task-bottom">
                    <TaskContactAvatars task={todo} />
                    <div className="task-time">
                        <div className="time-content">
                            <NwIcon icon={byPrefixAndName.fasl['alarm-exclamation']} />
                            <span>
                                Due on <strong>{showDateNoTime(todo.Date)}</strong>
                            </span>
                        </div>
                        {renderTag(todo)}
                    </div>
                </div>
            </TaskContainer>
            {editDrawer && (
                <EventDrawer
                    eventType="ToDo"
                    eventID={selectedId}
                    onClose={closeEditDrawer}
                    projectId={projectId}
                    afterUpdate={onUpdate}
                    afterRemove={onUpdate}
                />
            )}
        </>
    );
};

export default TaskCard;
